import type { FooterColPayment, FooterColText, StoreNavigationFooter } from '../../../types/footer';
import type { Translations } from '../../../types/translations';
import { mapContact } from './contact';
import { mapNavigation } from './navigation';
import { mapPayment } from './payment';
import { mapText } from './text';

export const mapCols = ({
  config,
  translations,
  instance,
}: {
  config: StoreNavigationFooter['config'];
  translations?: Translations;
  instance?: string;
}) =>
  config?.pt_footer_cols?.value.map((col, index) => {
    if (col.st_column_type === 'Footer__links') {
      return mapNavigation({ col, index, translations, instance });
    } else if (col.st_column_type === 'Footer__contact') {
      return mapContact({ col, index, translations, instance });
    } else if (col.st_column_type === 'Footer__text') {
      const val = col.st_elements.value[0];

      if (val && 'st_text' in val) {
        return mapText({ col: col as FooterColText, index, translations: translations, instance });
      } else if (val && 'st_items' in val) {
        return mapPayment({
          col: col as FooterColPayment,
          index,
          translations: translations,
          instance,
        });
      }
    }

    return {
      id: index,
      type: 'empty',
    } as const;
  });
